import type { AiCostCallRowPayload } from '@Application/AiCosts/Actions/aiCostCallsFetched';
import type PlainDate from '@Domain/PlainDate';
import toPlainDate from '@UI/Store/AiCosts/Views/toPlainDate';

type RelatedPayload = NonNullable<AiCostCallRowPayload['related']>;

/**
 * The object a call was made on: a generated document, or else an interview. `label` and `date` are
 * `null` once the object is deleted; an interview never has a `label`. `interviewKind` is only set for
 * an existing interview.
 */
class AiCostRelatedView {
	readonly kind: 'document' | 'interview';
	readonly id: number;
	readonly label: string | null;
	readonly date: PlainDate | null;
	readonly interviewKind: 'conversation' | 'notes' | null;

	constructor(payload: RelatedPayload) {
		this.kind = payload.kind;
		this.id = payload.id;
		this.label = payload.label;
		this.date = toPlainDate(payload.date);
		this.interviewKind = payload.interviewKind === null ? null : payload.interviewKind.value;

		Object.freeze(this);
	}
}

export default AiCostRelatedView;
